.root {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
